import { render, staticRenderFns } from "./LotegeneradoDetalleForm.vue?vue&type=template&id=0dad0825&"
import script from "./LotegeneradoDetalleForm.vue?vue&type=script&lang=js&"
export * from "./LotegeneradoDetalleForm.vue?vue&type=script&lang=js&"
import style0 from "./LotegeneradoDetalleForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LotegeneradoDetalleForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VListItem})
